import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Button, Input, message, Modal, Radio } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { useOfferDetailModel } from "./offerDetailModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { globalPrompt } from "@/components/message";
import { IOfferExamine } from '../../offerTypes';
import { useSalesDetailModel } from "@/views/sales/view/details/salesDetailModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { useOfferModel } from "../../offerModel";

const { TextArea } = Input;

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const { editFormVal,
        editFormVal: { status },
        getOfferDetailOne,
        resetPageCache,
        insertOrUpdateOffer, disableOffer, setOfferPdfDialog,
        submitOffer, examineManager, examineReckoner, transferOffer, materialExport
    } = useOfferDetailModel();
    const { updateFormVal: saleUpdateFormVal } = useSalesDetailModel(() => []);
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const { getTreeNodeName } = useDictModel(() => []);
    const { dataSource } = useOfferModel();
    const isEdit = mode === "edit";

    useEffect(() => {
        if (!editFormVal.id && mode === "edit") {
            //传过来的是code 把code转为id 如果找不到就使用传进来的值
            let i = dataSource.find(item => item.code === id)?.id || id
            getOfferDetailOne(i)
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("2-2-1") && resetPageCache("add")
            !findNav("2-2-2") && resetPageCache("edit");
        }
    }, [selectedNavId])


    const orderStatu: IDescription[] = [
        {
            label: "报价单",
            value: editFormVal.realCode,
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "驳回原因",
            value: editFormVal.status === DictCodeEnmu.QUOTE_DIR_REJECT ? editFormVal.advise ?? "" : editFormVal.adviseOne ?? "",
            color: DescriptionColorEnum.red,
            status: true,
            hidden: !(editFormVal.status === DictCodeEnmu.QUOTE_DIR_REJECT || editFormVal.status === DictCodeEnmu.QUOTE_FIN_REJECT) //财务 或者 总监已驳回时  展示驳回原因
        }
    ]


    //表单提交
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            insertOrUpdateOffer(mode, val).then(res => {
                if (mode === "add" && res) {
                    resetPageCache("edit");
                    replaceNav("2-2-1", "2-2-2", { id: res, mode: "edit" });
                }
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };

    //审批弹框
    const examineModal1 = (title: string) => {
        let obj: IOfferExamine = {
            status: "0",//默认是同意
        }
        Modal.confirm({
            title: title,
            content: <>
                <TextArea rows={4} placeholder="请输入审批意见" onChange={(e) => { obj.advise = e.target.value }} />
                <Radio.Group onChange={(e) => { obj.status = e.target.value }} defaultValue={obj.status}>
                    <Radio value={"0"}>同意</Radio>
                    <Radio value={"1"}>驳回</Radio>
                </Radio.Group>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    // if (obj.advise) {
                    resolve(obj);
                    // } else {
                    //     message.warning("请输入审批意见");
                    //     reject('请输入审批意见');
                    // }
                }).then((res: any) => {
                    examineManager({
                        code: editFormVal.code,
                        status: res.status,
                        advise: res.advise,
                    })
                });
            },
            onCancel: () => { }
        })
    }

    //审批弹框
    const examineModal2 = (title: string) => {
        let obj: IOfferExamine = {
            status: "0",//默认是同意
        }
        Modal.confirm({
            title: title,
            content: <>
                <TextArea rows={4} placeholder="请输入审批意见" onChange={(e) => { obj.advise = e.target.value }} />
                <Radio.Group onChange={(e) => { obj.status = e.target.value }} defaultValue={obj.status}>
                    <Radio value={"0"}>同意</Radio>
                    <Radio value={"1"}>驳回</Radio>
                </Radio.Group>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    // if (obj.advise) {
                    resolve(obj);
                    // } else {
                    //     message.warning("请输入审批意见");
                    //     reject('请输入审批意见');
                    // }
                }).then((res: any) => {
                    examineReckoner({
                        code: editFormVal.code,
                        status: res.status,
                        advise: res.advise,
                    })
                });
            },
            onCancel: () => { }
        })
    }

    const action = <>
        {isEdit && <>
            <YhAuth resCode={ResourceAuthEnum.O_ED_SUBMIT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={
                        !(status === DictCodeEnmu.QUOTE_INIT ||
                            status === DictCodeEnmu.QUOTE_DIR_REJECT ||
                            status === DictCodeEnmu.QUOTE_FIN_REJECT)
                    }
                    onClick={() => {
                        formRef.current?.validateFields().then((val: any) => {
                            submitOffer(editFormVal.code)
                        }).catch((err: ValidateErrorEntity<any>) => {
                            message.warning(getFormValidatorErrText(err));
                        })
                    }}
                >提交审核</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.O_ED_APPROVE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.QUOTE_PEND_APPROVE)}
                    onClick={() => examineModal1("总监审批")}
                >总监审批</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.O_ED_FIN_APPROVE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.QUOTE_DIR_APPROVE)}
                    onClick={() => examineModal2("财务审批")}
                >财务审核</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.O_ED_EXPORT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={
                        !(status === DictCodeEnmu.QUOTE_WAIT_FINISH ||
                            status === DictCodeEnmu.QUOTE_FINISH)
                    }
                    // onClick={() => { materialExport() }}
                    onClick={() => { setOfferPdfDialog(true) }}
                >导出报价单</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.O_ED_CANCEL}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={
                        !(status === DictCodeEnmu.QUOTE_INIT ||
                            status === DictCodeEnmu.QUOTE_FINISH)
                    }
                    onClick={() => {
                        globalPrompt("modal", {
                            title: "报价单作废",
                            text: ` `,
                            onOk: () => disableOffer(),
                        })
                    }}
                >作废</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.O_ED_TRANS}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={
                        !(status === DictCodeEnmu.QUOTE_WAIT_FINISH ||
                            status === DictCodeEnmu.QUOTE_FINISH)
                    }
                    onClick={() => {
                        transferOffer().then(res => {
                            if (res) {
                                saleUpdateFormVal("edit", null);
                                replaceNav("3-1-2", "3-2", { id: res, mode: "edit" })
                            }
                        })
                    }}
                >转外贸合同</Button>
            </YhAuth>
        </>}
        <YhAuth resCode={ResourceAuthEnum.O_ED_SAVE} isShow={mode === "add"}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { onSubmit() }}
            >保存</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "2-2")}
        >返回</Button>
    </>

    return (
        <YhBox
            title={orderStatu.map((item, index) => <Description key={index} {...item} />)}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}